/**
 * @generated SignedSource<<6768c1e7f031675d3d322ef0bc27a20d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CDPAudienceType = "LIST" | "SEGMENT" | "%future added value";
export type CDPType = "EMARSYS" | "KINN" | "KLAVIYO" | "OMETRIA" | "SHOPIFY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CDPAudienceFilters_brand$data = {
  readonly cdps: ReadonlyArray<{
    readonly audiences: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly type: CDPAudienceType;
    }>;
    readonly cdpType: CDPType;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"CDPAudienceLanguageSelector_brand">;
  readonly " $fragmentType": "CDPAudienceFilters_brand";
};
export type CDPAudienceFilters_brand$key = {
  readonly " $data"?: CDPAudienceFilters_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"CDPAudienceFilters_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CDPAudienceFilters_brand",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CDPAudienceLanguageSelector_brand"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLCDP",
      "kind": "LinkedField",
      "name": "cdps",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cdpType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLCDPAudienceType",
          "kind": "LinkedField",
          "name": "audiences",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "41a757862e4bb63a22bb3d4b4bb93072";

export default node;
